<div
  class="hd-just-now-transit-card-layer"
  (pointermove)="onLayerPointerMove($event)"
  (pointerup)="onLayerPointerUp($event)"
  (pointercancel)="onLayerPointerUp($event)"
>
  @for (stack of renderStacks(); track stack.key) {
    <div
      class="hd-just-now-transit-stack"
      [class.hd-just-now-transit-stack--dragging]="stackHasDrag(stack)"
      [style.left.%]="stackLeftPercent(stack)"
      [style.top.%]="stackTopPercent(stack)"
      [style.transform]="stackTransform(stack)"
    >
      @if (moveToolActive() && isPinned(stack)) {
        <span class="just-now-transit-pin-dot" aria-hidden="true"></span>
      }
      @for (card of stack.cards; track card.key) {
        <button
          type="button"
          class="hd-just-now-transit-card"
          [class.is-highlighted]="highlightedChannelKeys().has(card.key)"
          [class.is-dragging]="isDragging(card)"
          [style.background]="card.typeColor"
          [style.transform]="cardTransform(card)"
          (pointerdown)="onCardPointerDown(card, $event)"
          (dblclick)="onCardDblClick(card)"
          (mouseenter)="formationHovered.emit(card.formation)"
          (mouseleave)="formationHovered.emit(null)"
          (click)="onCardClick(card.formation, $event)"
        >
          <span class="hd-just-now-transit-card__planets">
            @for (planet of card.planets; track planet.key) {
              <span class="hd-just-now-transit-card__planet" [title]="planet.title">{{ planet.glyph }}</span>
            }
            @if (card.showBridge) {
              <i
                eIcon
                icon="bridge"
                class="hd-just-now-transit-card__bridge"
                [title]="t('humanDesign.chart.moonTransit.bridgeTooltip')"
              ></i>
            }
          </span>
          <span class="hd-just-now-transit-card__main">
            <span class="hd-just-now-transit-card__title">{{ card.title }}</span>
            @if (card.keynote) {
              <span class="hd-just-now-transit-card__keynote">{{ card.keynote }}</span>
            }
          </span>
          @if (card.centerIcons.length > 0) {
            <span class="hd-just-now-transit-card__centers">
              @for (icon of card.centerIcons; track icon.label) {
                <span class="hd-just-now-transit-card__center-icon" [title]="icon.label" [innerHTML]="icon.html"></span>
              }
            </span>
          }
        </button>
      }
    </div>
  } @empty {
    <p class="hd-just-now-transit-empty">{{ t('humanDesign.chart.justNowTransit.emptyState') }}</p>
  }
</div>
